import axios, { AxiosResponse } from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Accept": "application/json, text/plain",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  withCredentials: true,
});
const responseBody = (response: AxiosResponse) => response.data;

axiosInstance.interceptors.request.use(
  (config: any) => {
    try {
      var token = JSON.parse(localStorage.getItem("token") || "{}");
      if (!!token) {
        config.headers = { Authorization: `Bearer ${token}` };
      }
    } catch (error) {
      console.log(error);
    }
    return config;
  },
  function (error) {
    //Do something with request error
    return Promise.reject(error);
  }
);

const api = {
  get: (url: string, values?: any) => {
    if (!!values) {
      return axiosInstance.get(url, { params: values }).then(responseBody);
    } else {
      return axiosInstance.get(url, { params: values }).then(responseBody);
    }
  },

  post: (url: string, body?: {}) =>
    axiosInstance
      .post(url, body, { headers: { "Content-type": "application/json" } })
      .then(responseBody),

  del: (url: string) => axiosInstance.delete(url).then(responseBody),
};

export default api;
